import React from 'react';

const NotFound = () => (
    <h1>Pagina no encontrada</h1>
);

export default NotFound;